import React from "react";
import { useDispatch } from "react-redux";
import { Badge } from "react-bootstrap";
import { redirectUserTo } from "~/store/ducks/portalrh/actionTypes";
import { useRouteMatch } from "react-router-dom";
import { useHistory } from "react-router-dom";

import {
  setGenericRequestState,
  setGenericAuthorizationState,
} from "~/store/ducks/portalrh/actionTypes";

const RequestItem = (props) => {
  const dispatch = useDispatch();

  let { path } = useRouteMatch();
  const history = useHistory();

  const getAction = () => {
    for (var i = 0; i < Object.keys(props.allMenus).length; i++) {
      if (
        Object.values(props.allMenus)[i].designacao === props.description &&
        Object.values(props.allMenus)[i].nivel === 4 &&
        Object.values(props.allMenus)[i].accao.includes(props.type)
      ) {
        return Object.values(props.allMenus)[i].accao;
      }
    }
  };

  const onCLickHandler = () => {
    let url = "";
    if (props.type === "aut_ac_") {
      switch (props.description) {
        case "generic":
          dispatch(setGenericAuthorizationState(props.state));
          history.push(path + "/myteam/generic");

          break;
        case "expense":
          dispatch(setGenericAuthorizationState(props.state));
          history.push(path + "/myteam/expense");

          break;
        default:
          if (props?.flowId === 1) {
            history.push(path + "/myteam/generic");
          } else {
            url = "personalarea/frame/Pedidos";
          }
      }
    } else if (props.type === "ped_ac_") {
      switch (props.description) {
        case "vacationsManagement":
          dispatch(setGenericRequestState(props.state));
          url = "personalarea/frame/Pedidos";
          //history.push(path + "/personalarea/vacations");

          break;
        case "paymentData":
          dispatch(setGenericRequestState(props.state));
          url = "personalarea/frame/Pedidos";
          //history.push(path + "/personalarea/requests/payment");

          break;
        case "generic":
          dispatch(setGenericRequestState(props.state));
          history.push(path + "/personalarea/generic");

          break;
        case "expense":
          dispatch(setGenericRequestState(props.state));
          history.push(path + "/personalarea/expense");

          break;
        default:
          if (props?.flowId === 1) {
            history.push(path + "/personalarea/generic");
          } else {
            url = "personalarea/frame/Pedidos";
          }
      }
    }

    const object = {
      action: getAction(),
      url: url,
    };
    dispatch(redirectUserTo(JSON.stringify(object)));
  };

  return (
    <div style={{ cursor: "pointer" }}>
      <a onClick={() => onCLickHandler()} className="text-secondary">
        {props.t("portalrh.requests.descriptions." + props.description) + " "}
        <Badge pill className={props.textColor}>
          {props.num == "0" ? "" : props.num}
        </Badge>
      </a>
      <br />
    </div>
  );
};

export default RequestItem;
